import { useMemo, useCallback, useState } from 'react';
import './init-token-redemption-footer.scss';
import { ArrowLeft, ArrowRight } from 'assets/icons';
import { UiSelect, IconBtn } from '@ru-digital-assets/ui-component';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import {
  TokenRedemptionTypes,
  TokenRedemptionType,
} from 'constants/redemption';

interface IInitTokenRedemptionFooter {
  onCancel: () => void;
  onSubmit: (redemptionType: TokenRedemptionType) => void;
}

export default function InitTokenRedemptionFooter({
  onCancel,
  onSubmit,
}: IInitTokenRedemptionFooter) {
  const redemptionOptions = useMemo(
    () =>
      Object.entries(TokenRedemptionTypes).map(([value, label]) => ({
        value,
        label,
      })),
    []
  );

  const [redemptionType, setRedemptionType] = useState<TokenRedemptionType>();

  const onSubmitClick = useCallback(() => {
    onSubmit(redemptionType!);
  }, [redemptionType, onSubmit]);

  return (
    <div className="init-token-redemption-footer">
      <div
        className="init-token-redemption-footer__cancel-button"
        role="button"
        onClick={onCancel}
      >
        <ArrowLeft />
        <span className="p">Вернуться</span>
      </div>
      <div className="init-token-redemption-footer__controls">
        <UiSelect
          label="Выберите основание"
          options={redemptionOptions}
          onChange={(selected) => {
            if (selected) {
              setRedemptionType((selected as OptionType).value);
            }
          }}
        />
        <div className="init-token-redemption-footer__submit-button">
          <IconBtn
            title="Инициировать процедуру погашения токенов"
            icon={<ArrowRight color="#fff" />}
            disabled={!redemptionType}
            onClick={onSubmitClick}
          />
        </div>
      </div>
    </div>
  );
}
